import React, { Component } from "react";
import { Table, DatePicker, Button, Form, Select, message } from 'antd'
import moment from 'moment'
import { getDoctorWorkList, exportDoctorWorkList, getAllDoctorList } from '@/request/api'
import { requestErrorLog } from "@/common/util";


const { Option } = Select;
// 开始日期-结束日期
const defaultSelectDate = {
  startDate: moment().startOf('day').subtract(29, 'days'),
  endDate: moment().endOf('day')
};

class DoctorWork extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataStats: "",
      hospitalList: [],
      hospitalCode: '',
      doctorList: [],
      userId: '',
      selectPriceDate: '',
      offsetDays: 31536000000 * 5,
      startTime: '',
      endTime: '',
      tableList: [],
      columns: [
        {
          title: '',
          ellipsis: true,
          width: 200,
          children: [
            {
              title: '机构/科室名称',
              dataIndex: 'HOSPITAL_NAME',
              key: 'HOSPITAL_NAME',
              ellipsis: true,
              width: 200,
              align: 'center',
              render: (text, row) => {
                return {
                  children: text,
                  props: { rowSpan: row.rowSpan ?? 1 },
                }
              }
            }
          ]
        },
        {
          title: '',
          children: [
            {
              title: '医生姓名',
              dataIndex: 'REAL_NAME',
              key: 'REAL_NAME',
              ellipsis: true,
              width: 200,
              align: 'center'
            }
          ]
        },
        {
          title: '已报告病例量',
          children: [
            {
              title: '动态心电',
              dataIndex: 'REPORTHOLTERSUM',
              key: 'REPORTHOLTERSUM',
              align: 'center'
            },
            {
              title: '动态血压',
              dataIndex: 'REPORTBPSUM',
              key: 'REPORTBPSUM',
              align: 'center'
            },
            {
              title: '静息心电',
              dataIndex: 'REPORTECGSUM',
              key: 'REPORTECGSUM',
              align: 'center'
            },
            {
              title: '合计',
              dataIndex: 'REPORTSUM',
              key: 'REPORTSUM',
              align: 'center'
            },
          ]
        },
        {
          title: '已审核病例量',
          children: [
            {
              title: '动态心电',
              dataIndex: 'CHECKHOLTERSUM',
              key: 'CHECKHOLTERSUM',
              align: 'center'
            },
            {
              title: '动态血压',
              dataIndex: 'CHECKBPSUM',
              key: 'CHECKBPSUM',
              align: 'center'
            },
            {
              title: '静息心电',
              dataIndex: 'CHECKECGSUM',
              key: 'CHECKECGSUM',
              align: 'center'
            },
            {
              title: '合计',
              dataIndex: 'CHECKEDSUM',
              key: 'CHECKEDSUM',
              align: 'center'
            },
          ]
        },
      ]
    }
  }

  componentDidMount() {
    const userInfo = JSON.parse(localStorage.getItem('userInfo')) || {}
    this.setState({
      hospitalCode: userInfo.HOSPITAL_CODE,
    }, () => {
      this.handleSubmit()
      this.initHospitalList(userInfo)
      this.getDoctorList(userInfo.HOSPITAL_CODE)
    })
  }

  handleSubmit = (type) => {
    this.props.form.validateFields((err, values) => {
      if (values.startTime > values.endTime) {
        message.error('开始时间不得大于结束时间')
        return;
      }
      this.setState({
        startTime: moment(values.startTime).format('YYYY.MM.DD'),
        endTime: moment(values.endTime).format('YYYY.MM.DD')
      })
      let params = {
        HOSPITAL_CODE: this.state.hospitalCode,
        hospitalDateTime: [moment(values.startTime).format('YYYY-MM-DD'), moment(values.endTime).format('YYYY-MM-DD')],
        USER_UID: this.state.userId,
      }
      if (type === 'export') {
        exportDoctorWorkList(params).then(res => {
          if (res && res.Status === 1) {
            window.location.href = window.g.baseURL + "\\" + res.Result;
          }else {
            requestErrorLog('', '数据统计-导出医生工作量统计列表报错', 0,true)
          }
        })
      } else {
        getDoctorWorkList(params).then(res => {
          if (res && res.Status === 1) {
            let total = res.Result.total;
            let tableList = res.Result.data;
            let obj = {
              "HOSPITAL_NAME": "合计",
              "USER_UID": 'heji',
              'REAL_NAME': '',
              "REPORTHOLTERSUM": total.REPORT_HOLTE_TOTAL,
              "REPORTBPSUM": total.REPORT_BP_TOTAL,
              "REPORTECGSUM": total.REPORT_ECG_TOTAL,
              "REPORTSUM": total.REPORT_TOTAL,
              "CHECKHOLTERSUM": total.CHECK_HOLTE_TOTAL,
              "CHECKBPSUM": total.CHECK_BP_TOTAL,
              "CHECKECGSUM": total.CHECK_ECG_TOTAL,
              "CHECKEDSUM": total.CHECKED_TOTAL,
              "rowSpan": 1,
            }
            tableList.push(obj)
            let num = 1;
            let index = 0;
            for (let i = 1; i < tableList.length; i++) {
              if (tableList[i].HOSPITAL_NAME !== tableList[index].HOSPITAL_NAME) {
                tableList[index].rowSpan = num;
                num = 1;
              } else {
                num++;
                tableList[i].rowSpan = 0;
              }
            }
            this.setState({
              tableList,
            })
          }else {
            requestErrorLog('', '数据统计-医生工作量统计列表报错', 0,true)
          }
        })
      }
    });
  }

  selectHospital = (value) => {
    this.setState({
      hospitalCode: value
    })
  }

  getDoctorList = (code) => {
    getAllDoctorList(code).then(res => {
      if (res && res.Status === 1) {
        this.setState({
          doctorList: res.Result
        })
      }else {
        requestErrorLog('', '数据统计-医生工作量-获取所有医生报错', 0,true)
      }
    })
  }

  disabledDate = (current) => {
    if (this.state.selectPriceDate) {
      let selectV = moment(this.state.selectPriceDate, 'YYYY-MM-DD').valueOf()
      return current > moment(new Date(selectV + this.state.offsetDays).getTime()) ||
        current < moment(new Date(selectV - this.state.offsetDays).getTime()) ||
        current > moment().endOf('day')
    } else {
      return current > moment().endOf('day')
    }
  }
  changeRangePicker = (e) => {
    this.setState({
      selectPriceDate: ''
    })
  }
  calendarPriceRangeChange = (date) => {
    this.setState({
      selectPriceDate: date[0]
    })
  }

  initHospitalList(userInfo) {
    this.setState({
      hospitalList: [{
        HOSPITAL_CODE: userInfo.HOSPITAL_CODE,
        HOSPITAL_NAME: userInfo.HOSPITAL_NAME
      }]
    })
  }
  changeDoctor = (userId) => {
    this.setState({
      userId
    })
  }

  render() {
    const { form: { getFieldDecorator } } = this.props;
    const { tableList, hospitalList, startTime, endTime, columns, doctorList } = this.state;
    return (
      <>
        <Form layout="inline" style={{ minWidth: "1260px" }}>
          <Form.Item label="日期选择" className="headerlable">
            {getFieldDecorator('startTime', { initialValue: defaultSelectDate.startDate })(
              <DatePicker
                style={{ width: 145 }}
                allowClear={false}
                placeholder='开始日期'
                disabledDate={this.disabledDate}
              />)}
            <span style={{ display: 'inline-block', textAlign: 'center', width: 15 }}>-</span>
            <Form.Item style={{ width: 110 }}>
              {getFieldDecorator('endTime', { initialValue: defaultSelectDate.endDate })(
                <DatePicker
                  style={{ width: 145 }}
                  allowClear={false}
                  placeholder='结束日期'
                  disabledDate={this.disabledDate}
                />)}
            </Form.Item>
          </Form.Item>
          <Form.Item label="机构/科室">
            {getFieldDecorator("hospitalCode", { rules: [{ required: true, message: '机构/科室名称不能为空！' }], initialValue: this.state.hospitalCode })(
              <Select style={{ width: 260 }} onChange={this.selectHospital} disabled>
                {hospitalList && hospitalList.map((item) => {
                  return <Option value={item.HOSPITAL_CODE} key={item.HOSPITAL_CODE}>{item.HOSPITAL_NAME}</Option>
                })}
              </Select>
            )}
          </Form.Item>
          <Form.Item label="审核/报告医生">
            {getFieldDecorator("doctorName", { initialValue: this.state.userId })(
              <Select style={{ width: 160 }} onChange={this.changeDoctor}>
                <Option value={''} >全部</Option>
                {doctorList && doctorList.map((item) => {
                  return <Option value={item.USER_UID} key={item.USER_UID}>{item.REAL_NAME}</Option>
                })}
              </Select>
            )}
          </Form.Item>
          <Button style={{ marginLeft: '10px', marginTop: '4px' }} onClick={this.handleSubmit}>查询</Button>
          <Button style={{ marginLeft: '10px', marginTop: '4px' }} onClick={this.handleSubmit.bind(this, 'export')}>导出</Button>
        </Form>
        <div className="wrap statisticsTableBox" style={{ minWidth: "1260px" }}>
          <Table
            columns={columns}
            dataSource={tableList}
            bordered
            rowKey={(record, index) => record.USER_UID + index} // 需要修改为唯一的ID！
            pagination={false}
            scroll={{ y: 640 }}
            title={() => (
              <div className="tableHeader">
                <p>查询日期：{startTime} --- {endTime}</p>
              </div>
            )}
          >

          </Table>
        </div>
      </>
    );
  }
}

export default Form.create()(DoctorWork);
